import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getScheduledJobsSlice = createApi('GetScheduledJobsSlice', 'GET');

const GetScheduledJobsSlice = createSlice({
  name: 'GetScheduledJobsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getScheduledJobsSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getScheduledJobsSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getScheduledJobsSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default GetScheduledJobsSlice.reducer;
